import { HighlightedAppLocationViewCounts } from "../api/faq/getHighlightedAppLocationViews";
import { HighlightedFaqViewCounts } from "../api/faq/getHighlightedFaqViews";
import { CRMAppLocationIdentifier, FaqAppLocation } from "../types/Faq";
import APDetailRow from "./APDetailRow";
import AppLocation, { FaqContextIds } from "./AppLocation";

const FaqDetailRow = ({
  label,
  value,
  appLocationIdentifier,
  appLocations,
  highlightedFaqViews,
  highlightedAppLocationViews,
  contextIds,
}: {
  label: string;
  value: string;
  appLocationIdentifier: CRMAppLocationIdentifier;
  appLocations: FaqAppLocation[];
  highlightedFaqViews: HighlightedFaqViewCounts;
  highlightedAppLocationViews: HighlightedAppLocationViewCounts;
  contextIds: FaqContextIds;
}) => {
  return (
    <APDetailRow
      label={label}
      value={value}
      leftWrapper={{
        component: AppLocation,
        props: {
          appLocations: appLocations,
          appLocationIdentifier: appLocationIdentifier,
          highlightedFaqViews: highlightedFaqViews,
          highlightedAppLocationViews: highlightedAppLocationViews,
          contextIds: contextIds,
        },
      }}
      rightWrapper={{
        component: AppLocation,
        props: {
          appLocations: appLocations,
          appLocationIdentifier: appLocationIdentifier,
          highlightedFaqViews: highlightedFaqViews,
          highlightedAppLocationViews: highlightedAppLocationViews,
          contextIds: contextIds,
          hideHighlight: true,
        },
      }}
    />
  );
};

export default FaqDetailRow;
